// action types

export const ADD_TODO = "ADD_TODO";
export const TOGGLE_TODO = "TOGGLE_TODO";

// succinct hack for generating passable unique ids
const uid = () =>
  Math.random()
    .toString(34)
    .slice(2);

// action creators

export function addTodo(text) {
  return {
    type: ADD_TODO,
    payload: {
      id: uid(),
      isDone: false,
      text: text
    }
  };
}

export function toggleTodo(id) {
  return {
    type: TOGGLE_TODO,
    payload: id
  };
}



// WEBPACK FOOTER //
// ./src/actions/index.js